// extracted by mini-css-extract-plugin
export default {"containerBg":"Popover_containerBg__iKz0Q","popoverBox":"Popover_popoverBox__tmdSw","menu":"Popover_menu__oJPpa"};